import React from "react";

function Header() {
    return (
        <>
            <div className="hero-backgrounds">
                <div className="hero-background-tentang-kami"/>
            </div>
            <article className="hero ebp tentang-kami">
                <div className="hero-message-wrapper ebp">
                    <h1>
                        Tentang Kami
                    </h1>
                    <br/>
                    <p>Kami adalah penyelenggara Layanan Pendanaan Bersama Berbasis Teknologi Informasi yang telah
                        berizin dan diawasi Otoritas Jasa Keuangan (OJK) sesuai dengan surat keputusan nomor
                        <strong> KEP-76/D.05/2021</strong> tanggal 19 Agustus 2021 tentang Pemberian Izin Usaha
                        Perusahaan Penyelenggara Layanan Pinjam Meminjam
                        Uang Berbasis Teknologi Informasi.</p>
                    <br/>
                    <p>
                        Kami mempertemukan Penerima Dana dan Pemberi Dana melalui platform <strong>Danai.id.</strong>
                    </p>
                    <br/>
                </div>
            </article>
        </>
    );
}

export default Header;
